module.exports = __webpack_public_path__ + "img/sand-decal-12.013e4149.png";